import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { FormControl, } from '@tribeplatform/react-ui-kit/FormControl';
export function Checkbox({ name, validation, ...rest }) {
    const { register, formState } = useFormContext();
    const error = formState.errors[name];
    return (_jsx(FormControl.Checkbox, { name: name, invalid: !!(error === null || error === void 0 ? void 0 : error.message), error: error === null || error === void 0 ? void 0 : error.message, ...register(name, validation), ...rest }, void 0));
}
//# sourceMappingURL=Checkbox.js.map